import MuiStepLabel from "@material-ui/core/StepLabel";
import React from "react";
export interface StepLabelProps {
    /**
     * In most cases will simply be a string containing a title for the label.
     */
    children?: React.ReactNode;
    /**
     * Props applied to the `StepIcon` element.
     */
    StepIconProps?: {
        /**
         * Mark the step as completed. Is passed to child components.
         */
        completed?: boolean;
        /**
         * Mark the step as failed.
         */
        error?: boolean;
        /** Classes to be applied to specific step states. */
        classes?: {
            completed?: string;
        };
    };
}
export function StepLabel({ StepIconProps, children, ...props }: StepLabelProps) {
    // MUI injects some additional props to StepLabel so we must spread in any excess props.
    return (<MuiStepLabel StepIconProps={StepIconProps} {...props}>
            {children}
        </MuiStepLabel>);
}
